import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationValidityKey } from '../../utils/keys';
export const useValidateToken = (options) => {
    const { useQueryOptions, fields, variables } = options || {};
    const { client } = useTribeClient();
    const memberInvitationValidityKey = getMemberInvitationValidityKey({
        variables,
        fields,
    });
    return useQuery(memberInvitationValidityKey, () => client.invitations.validate(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useValidateToken.js.map